module.exports = __webpack_public_path__ + "static/img/home1.1046c163.png";